import { createApiRef } from '@backstage/core-plugin-api';
import type {
  CreateTechRadarEntryInput,
  CreateTechRadarTimelineInput,
  TechRadarEntry,
  TechRadarTimelineEntry,
  UpdateTechRadarEntryInput,
  UpdateTechRadarTimelineInput,
} from '@internal/backstage-plugin-tech-radar-common';

export type TechRadarApi = {
  listEntries(): Promise<TechRadarEntry[]>;
  getEntry(id: string): Promise<TechRadarEntry>;
  createEntry(input: CreateTechRadarEntryInput): Promise<TechRadarEntry>;
  updateEntry(
    id: string,
    update: UpdateTechRadarEntryInput,
  ): Promise<TechRadarEntry>;
  deleteEntry(id: string): Promise<void>;
  listTimeline(entryId: string): Promise<TechRadarTimelineEntry[]>;
  getTimeline(
    entryId: string,
    timelineId: string,
  ): Promise<TechRadarTimelineEntry>;
  createTimeline(
    entryId: string,
    input: CreateTechRadarTimelineInput,
  ): Promise<TechRadarTimelineEntry>;
  updateTimeline(
    entryId: string,
    timelineId: string,
    update: UpdateTechRadarTimelineInput,
  ): Promise<TechRadarTimelineEntry>;
  deleteTimeline(entryId: string, timelineId: string): Promise<void>;
};

export const techRadarApiRef = createApiRef<TechRadarApi>({
  id: 'plugin.tech-radar.service',
});
